import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';
import clsx from 'clsx';

@Component({
  tag: 'theme-button',
  styleUrl: 'theme-button.scss',
  shadow: true,
})
export class ThemeButton {
  @Event() press: EventEmitter<void>;
  @Prop() variation: 'filled' | 'outline' | 'borderless' = 'outline';
  @Prop() disabled: boolean = false;
  @Prop() isLoading: boolean = false;
  @Prop() isError: boolean = false;

  handleClick = () => this.press.emit();

  render() {
    return (
      <button onClick={this.handleClick} class={clsx([this.variation, this.isError && 'error'])} disabled={this.disabled || this.isLoading}>
        {this.isLoading ? (
          <div class="loading">
            <loading-spinner />
            <div class="text-placeholder">
              <slot />
            </div>
          </div>
        ) : (
          <Fragment>
            <slot name="icon" />
            <slot />
          </Fragment>
        )}
      </button>
    );
  }
}
